document.addEventListener('DOMContentLoaded', function() {
  // Only run on search pages
  if (!window.location.pathname.includes('/search')) return;
  
  // Check if we're already on a search page with results
  const searchParams = new URLSearchParams(window.location.search);
  const searchParamsExist = searchParams.has('q');
  
  // If we're already on a search page with results but no availability filter,
  // redirect immediately to add the filter
  if (searchParamsExist && !searchParams.has('filter.v.availability')) {
    const url = new URL(window.location.href);
    url.searchParams.set('filter.v.availability', '1');
    window.location.href = url.toString();
    return; // Stop execution since we're redirecting
  }
  
  /**
   * Locate the availability filter in Dawn theme
   * - In Dawn 15.0.0, filters are in facets-filters-form
   */
  function setAvailabilityFilter() {
    // Find the availability filter checkbox
    const availabilitySection = Array.from(document.querySelectorAll('.facets__display')).find(
      el => el.textContent.trim().toLowerCase().includes('availability')
    );
    
    if (!availabilitySection) return;
    
    // Find the "In stock" checkbox within that section
    const inStockLabel = Array.from(availabilitySection.nextElementSibling.querySelectorAll('label')).find(
      label => label.textContent.trim().toLowerCase().includes('in stock')
    );
    
    if (!inStockLabel) return;
    
    const checkbox = inStockLabel.querySelector('input[type="checkbox"]');
    
    if (checkbox && !checkbox.checked) {
      // Check the "In stock" checkbox if it's not already checked
      checkbox.checked = true;
      
      // Trigger change event to activate the filter
      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      
      // Always submit the form to apply the filter immediately 
      const form = checkbox.closest('form');
      if (form) {
        // Ensure any required hidden inputs for search are preserved
        if (searchParamsExist && !form.querySelector('input[name="q"]')) {
          const queryInput = document.createElement('input');
          queryInput.type = 'hidden';
          queryInput.name = 'q';
          queryInput.value = searchParams.get('q');
          form.appendChild(queryInput);
        }
        
        setTimeout(() => {
          form.submit();
        }, 100);
      }
    }
  }
  
  /**
   * Alternative implementation if the above doesn't locate the filter
   * - This directly modifies the URL to include the availability filter
   */
  function setAvailabilityFilterViaURL() {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;
    
    // Only proceed if we're on a search page with a query
    if (!searchParams.has('q')) return;
    
    // Check if availability filter is already set
    if (!searchParams.has('filter.v.availability')) {
      // Add the in-stock filter
      searchParams.set('filter.v.availability', '1');
      
      // Update the URL and reload the page
      window.location.href = url.toString();
    }
  }
  
  // Try the DOM method first
  if (document.readyState === 'complete') {
    setAvailabilityFilter();
  } else {
    // If page is still loading, wait for it to complete
    window.addEventListener('load', setAvailabilityFilter);
  }
  
  // Always try the direct URL method if DOM method doesn't work immediately
  setTimeout(() => {
    // If the filter still isn't checked after 1 second, use URL approach
    const filterApplied = document.querySelector('.active-facets__button');
    const availabilityFilterActive = filterApplied && 
                                    filterApplied.textContent.toLowerCase().includes('availability');
    
    if (!availabilityFilterActive && searchParamsExist) {
      setAvailabilityFilterViaURL();
    }
  }, 1000);
});